function showErrorMsg(form, type, msg) {

    var alert = $('<div class="alert alert-' + type + ' alert-dismissible" role="alert">\
            <div class="alert-text">'+msg+'</div>\
            <div class="alert-close">\
                <i class="flaticon2-cross icon-sm" data-dismiss="alert"></i>\
            </div>\
        </div>');

    form.find('.alert').remove();
    alert.prependTo(form);
    KTUtil.animateClass(alert[0], 'fadeIn animated');
    alert.find('span').html(msg);

}

function createCookie(name, value, days) {

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    }

    else var expires = "";               

    document.cookie = name + "=" + value + expires + "; path=/";

}

function displayForgotForm() {

    var login = $('#login');

    login.removeClass('login--signin');
    login.removeClass('login--signup');

    login.addClass('login--forgot');
    //login.find('.login--forgot').animateClass('flipInX animated');
    KTUtil.animateClass(login.find('.login__forgot')[0], 'flipInX animated');

}

function displaySignInForm() {

    var login = $('#login');

    login.removeClass('login--forgot');
    login.removeClass('login--signup');

    login.addClass('login--signin');
    KTUtil.animateClass(login.find('.login__signin')[0], 'flipInX animated');
    //login.find('.login__signin').animateClass('flipInX animated');

}

function loginEventHandlers() {

    $('#login_forgot').click(function(e) {
        e.preventDefault();
        displayForgotForm();
    });

    $('#login_forgot_cancel').click(function(e) {
        e.preventDefault();
        displaySignInForm();
    });

    $("#signinsubmit").click(function (e) {
      e.preventDefault();
      var btn = $(this);
      var form = $(this).closest("form");

      btn
        .addClass("spinner spinner--right spinner--sm spinner--light")
        .attr("disabled", true);

      grecaptcha.ready(function () {
        grecaptcha
          .execute(site_key, { action: "submit" })
          .then(function (token) {
            form.validate({
              rules: {
                loginemail: {
                  required: true,
                  email: true,
                },
                loginpassword: {
                  required: true,
                },
              },
            });

            form.append(
              '<input type="hidden" name="g-recaptcha-response" value="' +
                token +
                '">'
            );

            if (!form.valid()) {
              return;
            }

            form.serialize();

            form.ajaxSubmit({
              url:
                "https://" +
                document.location.hostname +
                "/api/v2/Auth/UserLogin.php",
              type: "post",
              success: function (response, status, xhr, $form) {
                var obj = $.parseJSON(response);
                var stat = obj.status;
                var write = obj.write;

                if (stat == 200) {
                  var count = obj.count;
                  btn
                    .removeClass(
                      "spinner spinner--right spinner--sm spinner--light"
                    )
                    .attr("disabled", false);

                  if (count > 0) {
                    var userID = obj.id;
                    var email = obj.email;
                    var location = obj.location;
                    var fullname = obj.fullname;
                    var userstatus = obj.userstatus;
                    var uclass = obj.uclass;

                    createCookie("user_fullname", fullname, 365);
                    createCookie("uper", userID, 365);
                    createCookie("user_email", email, 365);
                    createCookie("user_location", location, 365);
                    createCookie("uclass", uclass, 365);

                    if (userstatus == 1) {
                      var needPW = obj.needpw;
                      if (needPW == 1) {
                        window.location.href =
                          "https://" +
                          document.location.hostname +
                          "/tmp-session-resetauth";
                      } else {
                        var urlParams = new URLSearchParams(window.location.search);
                        var redirectUrl = urlParams.get('redirect');
                        // Prevent open redirect vulnerabilities by validating redirect URL is local/relative
                        if (redirectUrl) {
                          var isSafe = false;
                          if (/^\/(?!\/)/.test(redirectUrl) && redirectUrl.indexOf('\\') === -1) {
                            isSafe = true;
                          } else {
                            try {
                              var parsedUrl = new URL(redirectUrl, window.location.origin);
                              if (parsedUrl.origin === window.location.origin) {
                                isSafe = true;
                              }
                            } catch (e) {
                              isSafe = !e || false;
                            }
                          }
                          if (isSafe) {
                            // nosemgrep: js-open-redirect
                            window.location.href = redirectUrl;
                          } else {
                            window.location.href =
                              "https://" +
                              document.location.hostname +
                              "/dashboard";
                          }
                        } else {
                          window.location.href =
                            "https://" +
                            document.location.hostname +
                            "/dashboard";
                        }
                      }
                    } else if (userstatus == 2) {
                      window.location.href =
                        "https://" + document.location.hostname + "/welcome";
                    } else {
                      showErrorMsg(
                        form,
                        "danger",
                        "There was a problem processing your request. Please try again."
                      );
                    }
                  } else {
                    showErrorMsg(
                      form,
                      "danger",
                      "The email/password you've entered doesn't match any account. Please try again."
                    );
                  }
                } else if (stat == 401) {
                  btn
                    .removeClass(
                      "spinner spinner--right spinner--sm spinner--light"
                    )
                    .attr("disabled", false);
                  showErrorMsg(
                    form,
                    "danger",
                    "Recaptcha failed. Please try again."
                  );
                } else {
                  btn
                    .removeClass(
                      "spinner spinner--right spinner--sm spinner--light"
                    )
                    .attr("disabled", false);
                  showErrorMsg(
                    form,
                    "danger",
                    "There was a problem processing your request. Please try again."
                  );
                }
              },
            });
          });
      });
    });

    $('#login_forgot_submit').click(function(e) {
            
        e.preventDefault();

        var btn = $(this);
        var form = $(this).closest('form');

        form.validate({
            rules: {
                email: {
                    required: true,
                    email: true
                }
            }
        });

        if (!form.valid()) {
            return;
        }

        btn.addClass('spinner spinner--right spinner--sm spinner--light').attr('disabled', true);

        form.ajaxSubmit({
            url: '',
            success: function(response, status, xhr, $form) {
                // similate 2s delay
                setTimeout(function() {
                    btn.removeClass('spinner spinner--right spinner--sm spinner--light').attr('disabled', false); // remove
                    form.clearForm(); // clear form
                    form.validate().resetForm(); // reset validation states

                    // display signup form
                    displaySignInForm();
                    var signInForm = login.find('.login__signin form');
                    signInForm.clearForm();
                    signInForm.validate().resetForm();

                    showErrorMsg(signInForm, 'success', 'Password reset instructions have been sent to your email address');
                }, 2000);
            }
        });
    });
}

// Class Initialization
jQuery(document).ready(function() {

    var login = $('#login');
    loginEventHandlers();

});
